var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.067 1.132L4.694 6.505a.566.566 0 00.8.8l5.374-5.372v1.92a.566.566 0 001.132 0V.567A.564.564 0 0011.43 0a.566.566 0 00-.396.166l-.967.966z",
    fill: "#333230"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 0H7.81a.566.566 0 000 1.132h2.256M0 2.377c0-.312.253-.566.566-.566h6.735a.566.566 0 010 1.132H1.132v7.925h7.925v-6.22a.566.566 0 011.132 0v6.786a.566.566 0 01-.566.566H.566A.566.566 0 010 11.434V2.377z",
    fill: "#333230"
  })));
}
export default SvgExternal;